import { Routes, Route } from "react-router-dom";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Licence from "../views/Licence/Licence";
import Landing from "../views/Landing/Landing";
import Login from "../views/Login/Login";
import NotFound from "../views/NotFound/NotFound";
import Profile from "../views/Profile/Profile";
import ProtectedRoute from "./ProtectedRoute";
import { StateContext } from "../contexts/state.context";

const Router = () => {
	const { currentSession, setCurrentSession } = useContext(StateContext);
	const hasSession = Boolean(currentSession?.authenticated);
	const navigate = useNavigate();
	// const hasSession = true;

	useEffect(() => {
		const handleSessionExpired = () => {
			setCurrentSession(null);
			navigate("/admin-login", { replace: true });
		};

		window.addEventListener("app:session-expired", handleSessionExpired);

		return () => {
			window.removeEventListener(
				"app:session-expired",
				handleSessionExpired,
			);
		};
	}, [navigate, setCurrentSession]);

	return (
		<Routes>
			<Route path="/" element={<Landing />} />
			<Route path="/admin-login" element={<Login />} />

			<Route element={<ProtectedRoute isAllowed={hasSession} />}>
				<Route path="/licence" element={<Licence />} />
				<Route path="/profile" element={<Profile />} />
			</Route>

			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};

export default Router;
